import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filter",
    pure: true
  })
  export class ArrayFilterPipe implements PipeTransform {
  
    transform(items: Array<any>, conditions: {[field: string]: any}): Array<any> {

        return items.filter(item => {
            for (let field in conditions) {
                if (item[field] !== conditions[field] && conditions[field] !== 'Alles') {
                    return false;
                }
            }
            return true;
        });
    }
  }



// WEBPACK FOOTER //
// ./src/pipes/array-filter/array-filter.ts